export default __webpack_public_path__ + "static/media/Teknion Private Office.146bb15f.jpg";